import { render, staticRenderFns } from "./touristische-planung-status-bar.vue?vue&type=template&id=55dd2ac7&scoped=true"
import script from "./touristische-planung-status-bar.vue?vue&type=script&lang=js"
export * from "./touristische-planung-status-bar.vue?vue&type=script&lang=js"
import style0 from "./touristische-planung-status-bar.vue?vue&type=style&index=0&id=55dd2ac7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd2ac7",
  null
  
)

export default component.exports